module.exports = __webpack_public_path__ + "img/album14_01.67203ada.jpg";